export default __webpack_public_path__ + "static/media/banner_3.ff864e70.png";